import { render } from "./ServiciosES.vue?vue&type=template&id=fd6eae02&scoped=true"
import script from "./ServiciosES.vue?vue&type=script&lang=js"
export * from "./ServiciosES.vue?vue&type=script&lang=js"

import "./ServiciosES.vue?vue&type=style&index=0&id=fd6eae02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6eae02"]])

export default __exports__